import { TableHelp } from "../help/table_help";

const {ccclass, property} = cc._decorator;
//寻找好友组件
@ccclass
export class SeekPlayerComponent extends cc.Component {
    @property(cc.Float)
    interval:number = 0;

    @property([cc.Node])
    points:cc.Node[] = [];

    onEnable(){
        this.node.stopAllActions();
        let index = 0;
        this.resetPoints();
        let firstPoint = this.points[index++]
        if (firstPoint) {
            firstPoint.active = true;
        }
        TableHelp.schedule(this.node,()=>{
            if (index >= this.points.length) {
                index = 0;
                this.resetPoints();   
            }else{
                let point = this.points[index];
                if (point) {
                    point.active = true;
                }
                index++;
            }
        },this.interval);
    }

    private resetPoints(){
        for (let point of this.points) {
            point.active = false;
        }
    }
}
